var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgA2Da9Aa45C7Bbb15Ef090F5C242Ca91De83B6739(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.348 3C3.95504 3 2 4.95503 2 7.34799C2 10.3196 5.89443 14.6833 6.05083 14.871C6.20723 15.043 6.47312 15.043 6.62952 14.871C6.80157 14.6833 10.6804 10.3196 10.6804 7.34799C10.6804 4.95503 8.72532 3 6.33236 3H6.348ZM6.348 9.52199C5.1437 9.52199 4.15836 8.53666 4.15836 7.33236C4.15836 6.12806 5.1437 5.14272 6.348 5.14272C7.5523 5.14272 8.53763 6.12806 8.53763 7.33236C8.53763 8.53666 7.5523 9.52199 6.348 9.52199Z",
    fill: "var(--fill-0, #00B14F)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA2Da9Aa45C7Bbb15Ef090F5C242Ca91De83B6739);
export default __webpack_public_path__ + "static/media/a2da9aa45c7bbb15ef090f5c242ca91de83b6739.e6dcae71c5527372cb97d230a568e8de.svg";
export { ForwardRef as ReactComponent };